import { useCallback } from "react";
import { useFeatureRasterStyle } from "./useFeatureRasterStyle";
import { FeatureDcExtended } from "../../../ducks/selectFeatures/types";

export const useRasterToggle = (feature?: FeatureDcExtended): [boolean, VoidFunction] => {
  const { featureStyle, updateRasterStyle } = useFeatureRasterStyle(feature);

  const rasterIsShowed = !featureStyle || !!(featureStyle.raster && featureStyle.raster.opacity);

  const handleToggle = useCallback(() => {
    updateRasterStyle(!rasterIsShowed);
  }, [updateRasterStyle, rasterIsShowed]);

  return [rasterIsShowed, handleToggle];
};
